export default __webpack_public_path__ + "static/media/link.ec4d86cd.svg";